import type { JsonObject, JsonValue } from "./json";

export type UploadDeliveryRegion = "cn" | "global";

export function modelUploadRegion(regions: readonly string[]): UploadDeliveryRegion {
  return regions.length > 0 && regions.every(region => /^cn(?:-|$)/.test(region.trim().toLowerCase())) ? "cn" : "global";
}

export function uploadedMediaUrl(value: string, region: UploadDeliveryRegion): string {
  if (!value.startsWith("https://")) return value;
  try {
    const url = new URL(value);
    if (url.username || url.password || url.port || !["tos.nexra-ai.com", "tos2.nexra-ai.com", "upload.nexra-ai.com"].includes(url.hostname)
      || !url.pathname.startsWith("/user-assets/") || url.pathname === "/user-assets/") return value;
    url.hostname = region === "cn" ? "tos.nexra-ai.com" : "tos2.nexra-ai.com";
    return url.href;
  } catch {
    return value;
  }
}

export function uploadedMediaInput(input: JsonObject, region: UploadDeliveryRegion): JsonObject {
  const visit = (value: JsonValue): JsonValue => {
    if (typeof value === "string") return uploadedMediaUrl(value, region);
    if (Array.isArray(value)) return value.map(visit);
    if (value !== null && typeof value === "object") {
      return Object.fromEntries(Object.entries(value).map(([key, item]) => [key,
        ["text", "texts", "prompt", "negative_prompt", "negativePrompt"].includes(key) ? item : visit(item)]));
    }
    return value;
  };
  return visit(input) as JsonObject;
}
